import { action, makeObservable, observable } from 'mobx';

export const SNACKBAR_TIMEOUT = 5000;

export default class Snackbar {
  @observable.deep public message: string | null = null;
  @observable.deep public actionText?: string;
  @observable.deep public actionHandler!: /* Fixme: http://tiny.cc/r4g9vz */ Function;
  @observable.deep public persistent?: boolean;

  private timeoutHandle?: ReturnType<typeof setTimeout> = undefined;

  constructor() {
    // eslint-disable-next-line no-restricted-syntax
    makeObservable(this);
  }

  @action.bound
  public hide(): void {
    this.message = null;
  }

  @action.bound
  public create(
    message: string,
    actionText?: string,
    actionHandler = (): any => {},
    persistent?: boolean,
  ): void {
    if (this.message === message) {
      return;
    }

    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }

    this.message = message;
    this.actionText = actionText;
    this.actionHandler = actionHandler;
    this.persistent = persistent;

    if (!persistent) {
      this.timeoutHandle = setTimeout((): void => this.hide(), SNACKBAR_TIMEOUT);
    }
  }
}
